package hk.com.vr360_demo2.webapp.component.viewer

import hk.com.vr360_demo2.webapp.component.marzipano.PanoramaLinkHotspot
import hk.com.vr360_demo2.webapp.component.marzipano.PanoramaSceneConfig
import hk.com.vr360_demo2.webapp.component.marzipano.PanoramaViewParameters
import hk.com.vr360_demo2.webapp.core.net.common.PanoramaDataJsonResult
import hk.com.vr360_demo2.webapp.core.ui_state.NetworkState
import hk.com.vr360_demo2.webapp.core.ui_state.ProgressBarState

data class ViewerState(
    val isLoading: Boolean = true,
    val panoramaData: PanoramaDataJsonResult? = null,
    val scenes: List<PanoramaSceneConfig> = emptyList(),
    val activeSceneIndex: Int = 0,
    val networkState: NetworkState = NetworkState.Good,
) {
    val progressBarState: ProgressBarState
        get() = when {
            !isLoading -> ProgressBarState.Idle
            scenes.isEmpty() -> ProgressBarState.FullScreenLoading
            else -> ProgressBarState.MessageLoading("正在加載..")
        }
}

sealed interface ViewerIntent {
    data object Refresh : ViewerIntent
    data class SwitchScene(val sceneIndex: Int) : ViewerIntent
}

sealed interface ViewerAction {
    data object InitialLoad : ViewerAction
}

sealed interface ViewerMessage {
    data object Loading : ViewerMessage
    data class LoadSuccess(
        val panoramaData: PanoramaDataJsonResult?,
        val scenes: List<PanoramaSceneConfig>,
    ) : ViewerMessage
    data class LoadFailure(val message: String) : ViewerMessage
    data class SceneSwitched(val sceneIndex: Int) : ViewerMessage
}

sealed interface ViewerEffect

internal fun PanoramaDataJsonResult?.toViewerScenes(): List<PanoramaSceneConfig> {
    return this?.modelInfoList?.map { modelInfo ->
        PanoramaSceneConfig(
            id = modelInfo.id,
            url = modelInfo.tilesUrl.ifEmpty { modelInfo.url },
            name = modelInfo.name,
            cover = modelInfo.cover,
            initialViewParameters = PanoramaViewParameters(
                yaw = modelInfo.initialViewParameters?.yaw,
                pitch = modelInfo.initialViewParameters?.pitch,
                fov = modelInfo.initialViewParameters?.fov,
            ),
            linkHotspots = modelInfo.linkHotspots.orEmpty().map { hotspot ->
                PanoramaLinkHotspot(
                    yaw = hotspot.yaw,
                    pitch = hotspot.pitch,
                    target = hotspot.target,
                    rotation = hotspot.rotation,
                    imageName = hotspot.imageName,
                )
            },
        )
    }.orEmpty()
}
